import { useMutation } from "@tanstack/react-query";
import "firebase/auth";
import { useFirebaseUser } from "../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../useSellarCurrentBusiness.shared";
import { ApiListParams, sellarApiRequest } from "./sellarApiRequest";

export type SellarApiRequestType = {
  path: string;
  method: "get" | "delete" | "post" | "put";
  params?: ApiListParams;
};

export const useApiRequestLegacy = <
  Request extends object,
  Response extends object,
>(
  params: SellarApiRequestType,
) => {
  const currentBusinessContext = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: Request) =>
      sellarApiRequest({
        user,
        business: currentBusinessContext?.business ?? null,
        method: params.method,
        path: params.path,
        params: params.params,
        data: data,
      }).then((response) => response.data.data as Response),
  });
};
